import { Role, Team, trackAnalytics, type AppConfiguration } from '@puffin/app-frame-api';
import { platformPuffinLogo } from '@puffin/ui-library';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { ConfigurationFields } from './ConfigurationFields';

interface ApplicationConfigurationWizardProps {
  firstName: string;
  onComplete: (configuration: AppConfiguration) => void;
}

export const ApplicationConfigurationWizard = ({ firstName, onComplete }: ApplicationConfigurationWizardProps) => {
  const [team, setTeam] = useState<Team>();
  const [role, setRole] = useState<Role>();
  const [open, setOpen] = useState(true);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      aria-labelledby="application-configuration-title"
      slotProps={{
        paper: { variant: 'outlined' },
        transition: { onExited: () => team && role && onComplete({ team, role }) },
      }}
    >
      <DialogTitle id="application-configuration-title" align="center">
        <img src={platformPuffinLogo} alt="" width={96} />
        <br />
        Hi {firstName}, welcome to the new Meisterplan Dev Experience!
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          <Typography color="text.secondary" align="center">
            Tell us a bit about you and we&apos;ll tailor the platform to your team.
          </Typography>
          <ConfigurationFields team={team} role={role} onTeamChange={setTeam} onRoleChange={setRole} />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button
          variant="contained"
          disabled={!role || !team || !open}
          onClick={() => {
            trackAnalytics('APPLICATION_CONFIGURATION_SAVED', { team, role, configurationUpdated: false });
            setOpen(false);
          }}
        >
          Let&apos;s go
        </Button>
      </DialogActions>
    </Dialog>
  );
};
